/*
 * @Author: cc
 * @Date: 2020-04-02 13:23:33
 * @LastEditTime: 2020-04-26 18:24:42
 * @LastEditors: zhaoqing
 * @FilePath: \xjmediacloud\app\resourceCenter\stock\stock_router.js
 * @Description: 
 */
'use strict';
angular.module('resCenterJTRouterModule', []).config(['$stateProvider', function($stateProvider) {
    $stateProvider.state('front.resourcectrl.stock.resource', {
        url: '/resource?fcode&media_id&change&name&historystore',
        views: {
            'resource@front.resourcectrl.stock': {
                templateUrl: './resourceCenter/stock/stock_tpl.html',
                controller: 'resourceCenterStockCtrl'
            }
        }
    }).state('front.resourcectrl.stock.quickpreview', {
        // historystore：新疆日报历史稿库
        url: '/quickpreview?fcode&nodename&media_id&change&guid&channeltype&theme&historystore',
        views: {
            'resource@front.resourcectrl.stock': {
                templateUrl: './resourceCenter/stock/quickPreview/main_tpl.html',

                controller: 'stockQuickPreviewCtrl'
            }
        }
    }).state('front.resourcectrl.stock.video', {
        url: '/video?fcode&media_id&change',
        views: {
            'resource@front.resourcectrl.stock': {
                templateUrl: './resourceCenter/stock/video/video_tpl.html',
                controller: 'videoStockCtrl'
            }
        }
    }).state('front.resourcectrl.stock.audio', {
        url: '/audio?fcode&media_id&change',
        views: {
            'resource@front.resourcectrl.stock': {
                templateUrl: './resourceCenter/stock/audio/audio_tpl.html',
                controller: 'audioStockCtrl'
            }
        }
    });
}]);
